import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const UnidadMedidaApp = lazy(() => import('./view/UnidadMedida'))

export const unidadMedidaRouteMap = {
  gestion: {
    path: '/unidadmedida/gestion',
    name: 'Unidades de Medida',
  },
  registro: {
    path: '/unidadmedida/nuevo',
    name: 'Nuevo Unidad Medida',
  },
  actualizar: {
    path: '/unidadmedida/actualizar/:id',
    name: 'Actualizar Unidad Medida',
  },
}
const unidadMedidaRoutes = [
  {
    path: unidadMedidaRouteMap.gestion.path,
    element: (
      <OperacionesProvider>
        <UnidadMedidaApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default unidadMedidaRoutes
